import userApi from '@/api/sy/user';
// import configApi from "@/api/web/config";
import commonJs from "@/utils/common.js"
import { onLine } from "@/utils/online";
import router from "@/router"
import basicApi from "@/api/config/basic"
// import { encryptDes, decryptDes } from '@/utils/des.js'
let Base64 = require('js-base64').Base64;

const user = {
  state: {
    id: null,
    name: '',
    changePwd: false, //true: 强制修改密码
    isDistrict: 0,
    // unitName: '',
    dataRange: 0,
    interval: null,
    activeTime: new Date(),
    fileConfig: null,
    attSize: 0,
    photoSize: 0,
    videoSize: 0,
  },
  getters: {
    hasIdentityInfo: state => {
      // console.log('state.id', state.id)
      return state.id != null
    },
    isLogin: state => {
      return commonJs.getCookie("token") ? true : false
    }
  },
  mutations: {
    SET_ID(state, id) {
      state.id = id
    },
    SET_NAME(state, name) {
      state.name = name
    },
    SET_CHANGEPWD(state, changePwd) {
      // console.log('SET_CHANGEPWD', state)
      state.changePwd = changePwd
    },
    SET_ISDISTRICT(state, isDistrict) {
      state.isDistrict = isDistrict
    },
    // SET_UNITNAME(state, unitName) {
    //   state.unitName = unitName;
    // },
    SET_DATA_RANGE(state, dataRange) {
      state.dataRange = dataRange
    },
    SET_INTERVAL(state, interval) {
      state.interval = interval;
    },
    SET_FILECONFIG(state, fileConfig) {
      state.fileConfig = fileConfig;
    },
    SET_ACTIVETIME(state, activeTime) {
      state.activeTime = activeTime;
    }
  },
  actions: {
    setChangePwd({ commit }, changePwd) {
      commit('SET_CHANGEPWD', changePwd)
    },
    setActiveTime({ commit }, activeTime) {
      commit('SET_ACTIVETIME', activeTime)
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        userApi.login(user).then(res => {
          // console.log(res)
          if (res.Code == 0) {
            commonJs.setCookie("token", res.Data.Token, 1);

            let loginInfo = {
              UserId: res.Data.Id,
              UserName: res.Data.Name,
              // UnitName: res.Data.UnitName
            }

            // console.log(loginInfo);
            localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
            resolve(res);
          } else {
            reject(res);
          }
        })
      })
    },
    loginByCert({ commit }, data) {
      return new Promise((resolve, reject) => {
        userApi.certLogin(data).then(res => {
          if (res.Code == 0) {
            commonJs.setCookie("token", res.Data.Token, 1);
            commonJs.setCookie("refresh", res.Data.RefreshToken, 1);
            let loginInfo = {
              UserId: res.Data.Id,
              UserName: res.Data.Name,
              ChangePwd: res.Data.ChangePwd,
              IsDistrict: res.Data.IsDistrict,
            }

            localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
            resolve(res);
          } else if(res.Code==2) {
            resolve(res);
          } else {
            reject(res);
          }
        })
      })
    },
    loginByMobile({ commit }, user) {
      return new Promise((resolve, reject) => {
        // //encryptDes
        // let key = "RDBCUIOH"

        // let info = { ...user };
        // info.Mobile = encryptDes(user.Mobile, key);
        // info.Pwd = encryptDes(user.Pwd, key);

        // let info1 = { ...user }
        // info1.Mobile = decryptDes(info.Mobile, key);
        // info1.Pwd = decryptDes(info.Pwd, key);
        // console.log('加密', info, '解密', info1);

        let info = { ...user };
        info.LoginId = Base64.encode(user.LoginId);
        info.Pwd = Base64.encode(user.Pwd);
        info.Code = Base64.encode(user.Code);
        info.VerCode = Base64.encode(user.VerCode);
        // console.log('info', info);

        userApi.loginByMobile(info).then(res => {
          // console.log('login', res)
          if (res.Code == 0) {
            commonJs.setCookie("token", res.Data.Token, 1);
            commonJs.setCookie("refresh", res.Data.RefreshToken, 1);
            // sessionStorage.setItem("token", res.Data.Token);
            // sessionStorage.setItem("refresh", res.Data.RefreshToken);
            let loginInfo = {
              UserId: res.Data.Id,
              UserName: res.Data.Name,
              ChangePwd: res.Data.ChangePwd,
              IsDistrict: res.Data.IsDistrict,
              DpName: res.Data.DpName,
              UserType:res.Data.Type,
            }

            localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
            resolve(res);
          } else if(res.Code==2) {
            resolve(res);
          } else {
            reject(res);
          }
        })
      })
    },
    loginByCode({ commit }, Code) {
      return new Promise((resolve, reject) => {

        userApi.loginByCode({Code}).then(res => {
          if (res.Code == 0) {
            commonJs.setCookie("token", res.Data.Token, 1);
            commonJs.setCookie("refresh", res.Data.RefreshToken, 1);
            let loginInfo = {
              UserId: res.Data.Id,
              UserName: res.Data.Name,
              ChangePwd: res.Data.ChangePwd,
              IsDistrict: res.Data.IsDistrict,
              DpName: res.Data.DpName,
            }
            localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
            resolve(res);
          } else {
            reject(res);
          }
        })
      })
    },
    getLimit({ state }) {
      // basicApi.info(1).then((res) => {
      //   let data = res.Data;
      //   if (res.Code == 0) {
      //     state.attSize = data.AttachmentSize;
      //     state.photoSize = data.PhotoSize;
      //     state.videoSize = data.VideoSize;
      //   } else {
      //     state.attSize = 0;
      //     state.photoSize = 0;
      //     state.videoSize = 0;
      //   }
      // });
      state.videoSize = 20;
      state.photoSize = 3;
      console.log("getLimit");
    },
    getIdentityInfo({ commit, dispatch, state }) {
      // console.log('getIdentityInfo')
      return new Promise((resolve, reject) => {

        var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

        // console.log('loginInfo',loginInfo)
        commit('SET_ID', loginInfo.UserId)
        commit('SET_NAME', loginInfo.UserName)
        commit('SET_CHANGEPWD', loginInfo.ChangePwd)
        commit('SET_ISDISTRICT', loginInfo.IsDistrict)

        // configApi.info().then(res => {
        //   // console.log('configApi', res.Data)
        //   if (res.Data) {
        //     var item = {
        //       VideoLimit: res.Data.VideoLimit, //视频大小限制
        //       PicLimit: res.Data.PicLimit, //图片大小限制
        //       AttachLimit: res.Data.AttachLimit, //文章附件大小限制
        //       FileLimit: res.Data.FileLimit, //下载类文件大小限制
        //       SpecialCover: res.Data.SpecialCover, //专题封面 - 0:停用 1:启用
        //       VideoCover: res.Data.VideoCover, //视频封面 - 0:停用 1:启用
        //     };
        //     commit('SET_FILECONFIG', item);
        //   }
        // })

        userApi.getPermission().then(res => {
          if (res.Data != null) {
            let dataRange = res.Data.Roles.some(item => item.DataRange == 1)
            commit('SET_DATA_RANGE', dataRange)
            function buildPermissionAndFullPath(menu) {
              res.Data.Menus.forEach((m, i) => {
                if (m.Pid == menu.MenuId) {
                  m.FullPath = menu.FullPath + '/' + m.Url;
                  m.PermissionPath = (menu.PermissionPath ? (menu.PermissionPath + '.') : "") + m.Url;
                  buildPermissionAndFullPath(m);
                }
              })
            }
            buildPermissionAndFullPath({ MenuId: 0, FullPath: "", PermissionPath: "" });
            commit("SET_PERMISSION_MENUS", res.Data.Menus, { root: true });
            // if (state.interval == null) {
            //   console.log('set_interval')
            //   dispatch("setInterval", setInterval(() => { onLine(); }, 60000));
            // }
            resolve(res.Data)
          }
        }).catch(error => {
          dispatch('logout')
          reject(error)
        })
      })
    },
    setInterval({ commit }, interval) {
      commit('SET_INTERVAL', interval)
    },
    clearInterval({ commit }) {
      commit('SET_INTERVAL', null)
    },
    onLine({ commit }) {
      console.log('isOnline');

      var now = new Date();
      var x = now - user.state.activeTime;
      let min = Math.round(x / 1000 / 60);// 转为分钟数
      console.log('时间间隔', min);
      if (min >=30) {
        userApi.logout().then(res => {
          // console.log('logout', user.state)
          commit('SET_ID', null)
          clearInterval(user.state.interval)
          commit('SET_INTERVAL', null)
          commit('CLEAR_VIEWS')
          commonJs.delCookie("token");
          commonJs.delCookie("refresh");
          localStorage.removeItem("loginInfo")
          router.push('/register')
        })
      } else {
        userApi.online();
      }
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        userApi.logout().then(res => {
          // console.log('logout', user.state)
          commit('SET_ID', null)
          clearInterval(user.state.interval)
          commit('SET_INTERVAL', null)
          resolve(res.Data)
        })
      })
    },
    refreshToken({ commit }) {
      return new Promise((resolve, reject) => {
        let data = {
          Token: commonJs.getCookie("token"),
          RefreshToken: commonJs.getCookie("refresh")
        }
        // console.log('rdata', data)
        userApi.refreshToken(data).then(res => {
          // console.log('refreshToken', res)
          if (res.Code == 0 && res.Data != null) {
            commonJs.setCookie("token", res.Data.Token, 1);
            commonJs.setCookie("refresh", res.Data.RefreshToken, 1);
            // sessionStorage.setItem("token", res.Data.Token);
            // sessionStorage.setItem("refresh", res.Data.RefreshToken);
          }
          resolve(res)
        })
      })
    },
    clearStorage({ commit }) {
      commonJs.delCookie("token");
      commonJs.delCookie("refresh");
      // commonJs.delCookie("loginInfo")

      // sessionStorage.removeItem("token")
      // sessionStorage.removeItem("refresh")
      localStorage.removeItem("loginInfo")
      // window.location.href = window.location.origin + '/#/register';
      // window.location.reload();
    },
  }
}
export default user
